import { toastManager } from "../DownloadTray/ToastManager";

// GR-4473: grid outcomes go through the app's toast, like the other admin grids.
export const showToast = (message: string, variant: "success" | "danger") => {
  toastManager.show({
    message,
    variant,
    icon: variant === "success" ? "check" : "alert",
    autoCloseMs: 6000,
  });
};
